export enum AUTOMATED_TEST_IDS {
    headerLogoutBtn = 'headerLogoutBtn',
    login = 'login',
    cookieRejectBtn = 'cookieRejectBtn'
}

export enum MENU_CSS_CLASSES {
    LEFT_MENU_SUB_PAGE = 'left-menu-sub-page',
    NOT_FOR_TOP_MENU = 'not-for-top-menu',
    NOT_FOR_LEFT_MENU = 'not-for-left-menu'
}

export enum CUSTOM_CSS_CLASSES {
    HIDE_PAGE_WITHOUT_SAFEBET_TAG = 'hide-page-without-safebet-tag',
    SIDE_MENU_MY_ACCOUNT_HIGHLIGHT = 'side-menu-my-account-highlight'
}
